import { createGlobalStyle } from 'styled-components'
import { giphyLightCharcoal, giphyRed } from './colors'
import code from './code'

const DocsPageGlobalStyles = createGlobalStyle`
	${code}

    body {
        background: white;
        color: black;
        min-width: 1240px;
    }

    html,
    body {
        text-size-adjust: none;
    }

    ul {
    	font-size: 18px;
    	line-height: 1.5rem;
    	margin: 20px 0;
    }

    table code {
        color: ${giphyRed};
        font-size: 16px;
        background-color: transparent;
    }

    table th:not(:first-child) {
        padding: 0 20px;
    }

    blockquote p {
    	color: ${giphyLightCharcoal};
    }

    table {
        word-break: break-all;
        table-layout: fixed;
    }

    div#response-codes table tr > :first-child {
    	width:70px;
    }

    div#response-codes table tr > :nth-child(2) {
    	width:135px;
    }

    .docsContainer h3 {
        margin: 0;
    }

    .docsContainer h3 + p {
    	margin-bottom: 10px;
    }

    .docsContainer p + h3 {
    	margin-top: 50px;
    }

    .docsContainer p {
    	margin-bottom: 30px;
    }

    .docsContainer h2 {
    	margin-bottom: 20px;
    }

    .docsContainer p + img {
    	margin-bottom: 40px;
    }

    .docsContainer h5 {
    	margin: 20px 0 0 0;
    }

    .rendition-type table tr > :nth-child(2) {
        width: 235px;
    }
`

export default DocsPageGlobalStyles
